// extracted by mini-css-extract-plugin
export default {"label":"LabelBox_label__M4qy8"};